<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<!-- <div class="wccard d-flex align-items-center mb-3 p-3">
  <span class="text-webbtree-green f-12 font-weight-500 ml-3 pointer" (click)="backToListing()"><i
      class="fa-solid fa-arrow-left mr-1"></i> Back</span>

    </div> -->


<div class="row">
  <div class="col-3 pr-0">
    <app-person-search-filter></app-person-search-filter>
  </div>
  <div class="col-9 pl-1 overflow-band">
    <app-company-comparison-overview></app-company-comparison-overview>

  </div>
</div>
